import React from 'react'

const Icons = () => {
    return (
        <>
        <div className="text-center text-xl bg-red-100 font-bold w-[100%] h-[100%]">
          Icons
        </div>
      </>
  )
}

export default Icons